import { Directive } from "@angular/core";
import { MatSelect } from "@angular/material";

@Directive({
  selector: "mat-select[appOpenOnFocus]"
})
export class OpenOnFocusDirective {
  constructor(select: MatSelect) {
    const nativeEl = select._elementRef.nativeElement;
    nativeEl.addEventListener("focus", () => {
      select.open();
    });
  }
}
